<HomeNavBar />
<InactivityModal />

<div class="container-fluid py-3">

    <!-- Title + Search -->

    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
        <h4 class="mb-0">Business Profiles</h4>

  <!-- Desktop version: natural width -->
  <div class="position-relative d-none d-md-block mt-0">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded"
      placeholder="Search here"
      v-model="businessSearch"
    >
  </div>

  <!-- Mobile version: full width -->
  <div class="position-relative d-block d-md-none w-100 mt-2">
    <i class="bi bi-search text-muted position-absolute top-50 start-0 translate-middle-y ms-3"></i>
    <input
      type="text"
      class="form-control form-control-sm ps-5 shadow-sm rounded w-100"
      placeholder="Search here"
      v-model="businessSearch"
    >
  </div>
</div>


    <!-- Add Business Button -->
    <div v-if="profile_domain || (cbo_domain && user_details.user_role==='admin')" class="mb-3">
        <button
            class="btn btn-primary btn-sm text-xxs rounded"
            data-bs-toggle="modal"
            data-bs-target="#company_profile_modal"
        >
            Add New Business
        </button>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
        <p class="mt-2 text-muted text-xxs">Loading businesses...</p>
    </div>

    <!-- Pinterest Grid -->
    <div v-else class="row full-width-mobile scrollable-container g-1">

        <div
            v-for="business in filteredBusinesses"
            :key="business.id"
            class="col-12 col-sm-4 col-lg-4 col-xl-2 mb-2"
        >
            <div class="card shadow-sm border-0 rounded h-100 ">

                <div class="card-body">

                    <!-- Logo + Name -->
                    <div class="d-flex mb-2">

                        <img
                            src="@/assets/images/business-briefcase.jpg"
                            class="rounded-circle border me-2"
                            width="40"
                            height="40"
                            alt="Logo"
                        />

                        <div>
                            <h6 class="mb-1 text-xxs fw-bold">
                                {{ business.company_name }}
                            </h6>

                            <!-- Stars -->
                            <div class="d-flex align-items-center">
                                <i
                                    v-for="star in 5"
                                    :key="star"
                                    class="bi me-1"
                                    :class="{
                                        'bi-star-fill text-warning': star <= Math.floor(business.rating || 0),
                                        'bi-star-half text-warning': star > Math.floor(business.rating || 0) && star - (business.rating || 0) < 1,
                                        'bi-star text-muted': star > (business.rating || 0)
                                    }"
                                ></i>

                                <span class="ms-1 text-xxs text-muted">
                                    ({{ business.totalRatings || 0 }})
                                </span>
                            </div>
                        </div>

                    </div>

                    <!-- Email -->
                    <p v-if="business.email" class="mb-1 text-muted text-xxs d-none">
                        {{ business.email }}
                    </p>

                    <!-- Location -->
                    <p class="mb-3 text-muted text-xxs">
                        <i class="bi bi-geo-alt me-1"></i>
                        {{ business.location }}
                    </p>

                    <!-- Button -->
                    <button
                        class="btn btn-primary btn-sm w-100 text-xxs rounded"
                        @click="view_profile(business)"
                    >
                        Visit Profile
                    </button>

                </div>
            </div>
        </div>

    </div>

    <!-- Empty State -->
    <div v-if="!loading && !filteredBusinesses.length" class="text-center py-5">
        <i class="bi bi-building fs-1 text-muted"></i>
        <p class="mt-2 text-muted text-xxs">No businesses found</p>
    </div>
</div>

<StickyNav />
